import {
    parseVideo,
    Video,
    VideoChangeSet,
    AddVideoInfo,
    EditVideoInfo,
    UploadDocumentIF,
    UpdateVideoSlideIF,
} from "./models/Video";
import getAxiosInstance from "../../common/mhiAxios";
import { parseVideoReaction, VideoReaction, VideoReactionChangeSet } from "./models/VideoReaction";
import { VideoComment, VideoCommentChangeSet } from "./models/VideoComment";
import { parseVideoExtraMaterial, VideoExtraMaterial } from "./models/VideoExtraMaterial";
import { FilterResult, Tag } from "./models/VideoFilter";
import qs from "qs";
import { parseTag } from "./models/VideoTag";

export default {
    getAllContents(userId: string): Promise<FilterResult> {
        return getAxiosInstance()
            .get("/api/getContentListByConditions", {
                params: {
                    userId: userId,
                    professionals: [],
                    programs: [],
                    projects: [],
                    tags: [],
                },
            })
            .then(({ data }) => {
                const result: FilterResult = {
                    videos: [],
                    slides: [],
                    contents: [],
                    tags: data.tags,
                };
                data.contentOutList.forEach((row: any) => {
                    if (row.fileType === "slidestock") {
                        result.contents.push(row);
                        result.slides.push(row);
                    } else {
                        result.videos.push(row);
                        result.contents.push(row);
                    }
                });
                return result;
            })
            .catch((error) => {
                return error;
            });
    },
    getAll(): Promise<Array<Video>> {
        return getAxiosInstance()
            .get("/api/video")
            .then(({ data }) => data.map(parseVideo))
            .catch((error) => {
                return error;
            });
    },
    get(id: number, userId: string): Promise<Video | undefined> {
        return getAxiosInstance()
            .get("/api/getVideoById", { params: { videoId: id, userId: userId } })
            .then(({ data }) => parseVideo(data))
            .catch((error) => {
                return error;
            });
    },
    create(videoData: FormData): Promise<Video> {
        return getAxiosInstance()
            .post("/api/video/upload", videoData)
            .catch((error) => {
                return error;
            });
    },
    update(id: number, changeSet: VideoChangeSet): Promise<Video> {
        return getAxiosInstance()
            .put(`/api/video/${id}`, changeSet)
            .then(({ data }) => parseVideo(data))
            .catch((error) => {
                return error;
            });
    },
    uploadExtraMaterial(id: number, fileData: FormData): Promise<VideoExtraMaterial> {
        return getAxiosInstance()
            .post(`/api/video/${id}/material/upload`, fileData)
            .then(({ data }) => parseVideoExtraMaterial(data.list[0]))
            .catch((error) => {
                return error;
            });
    },
    deleteExtraMaterial(materialId: number): Promise<void> {
        return getAxiosInstance()
            .delete(`/api/video/material/${materialId}`)
            .catch((error) => {
                return error;
            });
    },
    delete(id: number): Promise<void> {
        return getAxiosInstance()
            .delete(`/api/video/${id}`)
            .catch((error) => {
                return error;
            });
    },
    addViewingHistory(userId: string, id: number, ms: number): Promise<Video> {
        return getAxiosInstance()
            .post("/api/addViewingHistory", { userId: userId, videoId: id, progressMillis: ms })
            .catch((error) => {
                return error;
            });
    },
    incrementViews(userId: string, id: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/incrementViewCount", { userId: userId, videoId: id })
            .catch((error) => {
                return error;
            });
    },
    createReaction(changeSet: VideoReactionChangeSet): Promise<VideoReaction> {
        return getAxiosInstance()
            .post("/api/addReaction", changeSet)
            .then(({ data }) => parseVideoReaction(data))
            .catch((error) => {
                return error;
            });
    },
    addVideoComment(changeSet: VideoCommentChangeSet): Promise<VideoComment> {
        return getAxiosInstance()
            .post("/api/addVideoComment", changeSet)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    updateVideoComment(changeSet: VideoCommentChangeSet): Promise<VideoComment> {
        return getAxiosInstance()
            .post("/api/updateVideoComment", changeSet)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    deleteVideoComment(id: number, userId: number, videoId: number): Promise<VideoComment> {
        return getAxiosInstance()
            .post("/api/deleteVideoComment", { id, userId, videoId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    replayToVideoComment(changeSet: VideoCommentChangeSet): Promise<VideoComment> {
        return getAxiosInstance()
            .post("/api/replayToVideoComment", changeSet)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // 新規Tag作成
    createNewTag(newTag: string): Promise<Tag[] | undefined> {
        return getAxiosInstance()
            .post(`/api/createTag?tags=${newTag}`)
            .then(({ data }) => data.map(parseTag))
            .catch((error) => {
                return error.response.data;
            });
    },
    getTagList(tags: string[]): Promise<Tag[] | undefined> {
        return getAxiosInstance()
            .get("/api/getTagList", { params: { tags: qs.stringify(tags) } })
            .then(({ data }) => data.map(parseTag))
            .catch((error) => {
                return error;
            });
    },

    //ビデオ追加
    AddVideo(video: AddVideoInfo): Promise<any> {
        const params = new FormData();

        params.append(
            "file",
            video.file !== undefined && video.file !== null ? video.file : new File([""], "empty")
        );
        params.append(
            "imageFile",
            video.imageFile !== undefined && video.imageFile !== null
                ? video.imageFile
                : new File([""], "empty")
        );
        params.append(
            "video",
            new Blob([JSON.stringify(video.video)], {
                type: "application/json",
            })
        );
        // documentFile
        if (video.documentFile.length > 0) {
            video.documentFile.map((row) => params.append("documentFile", row));
        } else {
            params.append("documentFile", new File([""], "empty"));
        }

        // documentName
        if (video.documentName.length > 0) {
            let sendDocumetName = "";
            video.documentName.map((row) => {
                if (sendDocumetName !== "") {
                    sendDocumetName = sendDocumetName + "," + row;
                } else {
                    sendDocumetName = row;
                }
                return null;
            });

            params.append(
                "documentName",
                new Blob([sendDocumetName], {
                    type: "application/json",
                })
            );
        } else {
            params.append(
                "documentName",
                new Blob([JSON.stringify("")], {
                    type: "application/json",
                })
            );
        }
        return getAxiosInstance()
            .post("/api/upload", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオ編集
    EditVideo(video: EditVideoInfo): Promise<any> {
        const params = new FormData();
        params.append(
            "file",
            video.file !== undefined && video.file !== null ? video.file : new File([""], "empty")
        );
        params.append(
            "imageFile",
            video.imageFile !== undefined && video.imageFile !== null
                ? video.imageFile
                : new File([""], "empty")
        );
        params.append(
            "video",
            new Blob([JSON.stringify(video.video)], {
                type: "application/json",
            })
        );
        return getAxiosInstance()
            .post("/api/editVideo", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => parseVideo(data))
            .catch((error) => {
                return error;
            });
    },

    // ビデオ資料アップロード
    UploadDocument(document: UploadDocumentIF): Promise<any> {
        const params = new FormData();

        // userId
        params.append("userId", String(document.userId));

        // videoId
        params.append("videoId", String(document.videoId));

        // materialId
        if (document.materialId.length > 0) {
            let sendMaterialId = "";
            document.materialId.map((row) => {
                if (sendMaterialId !== "") {
                    sendMaterialId = sendMaterialId + "," + String(row);
                } else {
                    sendMaterialId = String(row);
                }
                return null;
            });
            params.append(
                "materialId",
                new Blob([sendMaterialId], {
                    type: "application/json",
                })
            );
        } else {
            params.append(
                "materialId",
                new Blob([JSON.stringify("")], {
                    type: "application/json",
                })
            );
        }

        // documentFile
        if (
            document.documentFile !== undefined &&
            document.documentFile !== null &&
            document.documentFile.length > 0
        ) {
            document.documentFile.map((row) => params.append("documentFile", row));
        } else {
            params.append("documentFile", new File([""], "empty"));
        }

        // documentName
        if (document.documentName.length > 0) {
            let sendDocumetName = "";
            document.documentName.map((row) => {
                if (sendDocumetName !== "") {
                    sendDocumetName = sendDocumetName + "," + row;
                } else {
                    sendDocumetName = row;
                }
                return null;
            });

            params.append(
                "documentName",
                new Blob([sendDocumetName], {
                    type: "application/json",
                })
            );
        } else {
            params.append(
                "documentName",
                new Blob([JSON.stringify("")], {
                    type: "application/json",
                })
            );
        }

        // 送信
        return getAxiosInstance()
            .post("/api/uploadMaterial", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //ビデオ削除
    DeleteVideo(videoId: number, videoType: string): Promise<void> {
        return getAxiosInstance()
            .get(`/api/deleteVideo?videoId=${videoId}&type=${videoType}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオスライド資料取得
    GetVideoSlide(videoId: string, fileId: string): Promise<void> {
        return getAxiosInstance()
            .get("/api/getVideoSlide", { params: { videoId: videoId, fileId: fileId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオスライド資料追加・編集
    UpdateVideoSlide(updateVideoSlide: UpdateVideoSlideIF): Promise<void> {
        const params = new FormData();
        params.append("videoId", String(updateVideoSlide.videoId));
        params.append(
            "file",
            updateVideoSlide.file !== undefined && updateVideoSlide.file !== null
                ? updateVideoSlide.file
                : new File([""], "empty")
        );
        params.append(
            "slideName",
            updateVideoSlide.slideName === "" ? "empty" : updateVideoSlide.slideName
        );
        params.append("isPublic", String(updateVideoSlide.isPublic));
        params.append(
            "videoSlides",
            new Blob([JSON.stringify(updateVideoSlide.videoSlides)], {
                type: "application/json",
            })
        );
        return getAxiosInstance()
            .post("/api/updateVideoSlide", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ビデオスライド資料削除
    DeleteVideoSlide(videoId: number): Promise<void> {
        return getAxiosInstance()
            .get(`/api/deleteVideoSlide?videoId=${videoId}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //　統計ビデオ情報更新
    UpdateVideoStatistics(
        userId: number,
        videoId: number,
        videoTag: string,
        videoTitle: string,
        videoImgUrl: string,
        viewDurationMillis: number,
        newWatch: boolean
    ): Promise<void> {
        return getAxiosInstance()
            .post("/api/updateStatistics", {
                userId: userId,
                videoId: videoId,
                videoTag: videoTag,
                videoTitle: videoTitle,
                videoUrl: videoImgUrl,
                viewDurationMillis: viewDurationMillis,
                newWatch: newWatch,
            })
            .catch((error) => {
                return error;
            });
    },
};
